<template>
  <div class="text-center">
    <b-row>
      <b-col>
        {{ $t('To read the QR code use Google Authenticator') }}: <a :href="playStore">Google Play Store</a> or
        <a :href="appStore">App Store</a>.
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col>
        <qrcode-vue :value="otpLink" :size="180"></qrcode-vue>
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col>
        {{ $t('Please ensure that the QR code has been successfully read before proceeding.') }}
      </b-col>
    </b-row>

    <b-button variant="primary" size="sm" class="m-1" @click="copyToken">
      {{ $t('Copy') }}
    </b-button>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';
export default {
  props: ['otpLink'],
  components: { QrcodeVue },
  data() {
    return {
      playStore:
        'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=pt_BR&gl=US&pli=1',
      appStore: 'https://apps.apple.com/br/app/google-authenticator/id388497605'
    };
  },
  methods: {
    copyToken() {
      navigator.clipboard.writeText(this.otpLink);
    }
  }
};
</script>

<style></style>
